import React, {useCallback, useEffect, useRef, useState} from "react";
import Slide from "../../components/Slideshow/slide";
import Footer from "../../components/Footer";
import {Maximize2, Minimize2} from "lucide-react";

/**
 * - Main page for the slideshow feature
 * - Contains navigation, slide content (profile + quote + recognition), and footer
 */
const SlideShowPage: React.FC = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const toggleFullscreen = useCallback(() => {
        if (!document.fullscreenElement) {
            containerRef.current?.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    }, []);

    useEffect(() => {
        const handleChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", handleChange);
        return () => document.removeEventListener("fullscreenchange", handleChange);
    }, []);

    return (
        <div ref={containerRef} className="min-h-screen lg:h-screen lg:overflow-hidden flex flex-col bg-gradient-to-b from-blue-950 to-blue-900 text-white relative">
            {/* --- Slide Content: Profile Card + Quote Card + Recognition Message --- */}
            <div className="flex-1 w-full px-4 md:px-8 pb-8 flex flex-col lg:min-h-0">
                <Slide isFullscreen={isFullscreen} />
            </div>

            {/* --- Footer --- */}
            {!isFullscreen && <Footer />}

            {/* Fullscreen toggle - hidden on mobile */}
            <button
                onClick={toggleFullscreen}
                className="hidden md:flex items-center justify-center fixed bottom-6 right-6 z-[9999] p-3 rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors text-white shadow-lg backdrop-blur-sm border border-white/20"
                title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                tabIndex={0}
            >
                {isFullscreen ? (
                    <Minimize2 className="h-6 w-6" />
                ) : (
                    <Maximize2 className="h-6 w-6" />
                )}
            </button>
        </div>
    );
};

export default SlideShowPage;
